import { render, staticRenderFns } from "./BonusAmount.vue?vue&type=template&id=31a9d2c0&scoped=true&"
import script from "./BonusAmount.vue?vue&type=script&lang=js&"
export * from "./BonusAmount.vue?vue&type=script&lang=js&"
import style0 from "./BonusAmount.vue?vue&type=style&index=0&id=31a9d2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9d2c0",
  null
  
)

export default component.exports